export default __webpack_public_path__ + "static/media/login_background.b3e97886.png";